export const VariableKeys = {
    FULL_MONTH: "fullMonth",
}